export default {
  getData(state) {
    return state.data;
  },
  getServices(state) {
    return state.services;
  },
  getTotal(state) {
    return state.total;
  },
  getDetail(state) {
    return state.detail;
  },
};
